import { render, staticRenderFns } from "./BranchNotificationDetail.vue?vue&type=template&id=130734a0&"
import script from "./BranchNotificationDetail.vue?vue&type=script&lang=js&"
export * from "./BranchNotificationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports